import { homeRoutes, homeNavigationItems } from "./router";
export class HomeModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[HomeModule] Registered");
        return {
            id: "home",
            name: "Home Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return homeRoutes;
    }
    getNavigationItems() {
        return homeNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[HomeModule] Unregistered");
        this.contracts = null;
    }
}
export default new HomeModule();
